import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'displayLongText'
})
export class DisplayLongTextPipe implements PipeTransform {

  //获取当前dom节点
  constructor(private dom: DomSanitizer) { }

  transform(value: any, longText?: string): any {
    
    value = value.toString()
    if(longText){
      if(longText.length <= 20){
        // 如果字符长度<=20
        return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer" title=${longText}>${longText}</span>`)
      } else if(longText.length > 20){
         // 如果字符长度>20,就只显示前20个字符,然后鼠标浮上去显示所有内容
         let subText = longText.substr(0,20);
        // return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer" title=${handlerName}  class="state-info">${handlers[0]+' 等：'}审批中</span>`)
        return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer" title=${longText}">${subText+'......'}</span>`)
      }
    } else {
      return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer" title="无数据"></span>`)
    }
  }

}
